import { render, staticRenderFns } from "./IconInput.vue?vue&type=template&id=af7b12e0&"
import script from "./IconInput.vue?vue&type=script&lang=js&"
export * from "./IconInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports